import type { SearchCategory } from '@bulknutrients/bulk-shared-lib/interfaces/Category';

import { SearchResultCardCategory } from '../SearchResultCardCategory';

export function CategoriesList({ data }: { data: SearchCategory[] }) {
  return (
    <div className="ga-search-list ga-search-categories flex flex-col gap-2.5 pb-8">
      {data.map((hit) => (
        <SearchResultCardCategory hit={hit} key={hit.slug} />
      ))}
    </div>
  );
}
